angular.module("acl.visualizer.dataGrid", [
  "acl.visualizer.dataTable",
  "acl.visualizer.model.tableConfig",
  "templates-visualizer",
]);
